import { ModelSchema } from "api/client/types/DjangoClient.types";
import { RunStatus } from "types/constants";

const TERMINAL_RUN_STATUSES = new Set([RunStatus.COMPLETE, RunStatus.FAILED]);

/**
 * Determines whether a run status represents a run that has finished
 * executing.
 * @param status
 * @returns `true` if the run has finished executing and `false` otherwise.
 */
export const isTerminalRunStatus = (
  status: ModelSchema["RunSchema"]["status"],
) => {
  return TERMINAL_RUN_STATUSES.has(status);
};
